import { render, staticRenderFns } from "./InventoryStockDetail.vue?vue&type=template&id=0f9780c3&scoped=true&"
import script from "./InventoryStockDetail.vue?vue&type=script&lang=js&"
export * from "./InventoryStockDetail.vue?vue&type=script&lang=js&"
import style0 from "./InventoryStockDetail.vue?vue&type=style&index=0&id=0f9780c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9780c3",
  null
  
)

export default component.exports